import { allOr } from "@animus/generic-utils";
import { createConsoleAdapter } from "@animus/observability/adapters/console";
import { parseEnvironment } from "@animus/utils/environment";

import { type Environment, EnvironmentSchema } from "./schema";

const logger = createConsoleAdapter().createLogger({ name: "environment" });

function loadEnvironment(): Environment {
  const raw = {
    DEPLOY_ENVIRONMENT: import.meta.env.DEPLOY_ENVIRONMENT,
    GIT_SHA: import.meta.env.GIT_SHA,
    APP_VERSION: import.meta.env.APP_VERSION,
    API_BASE_URL: import.meta.env.API_BASE_URL,
    ZERO_CACHE_URL: import.meta.env.ZERO_CACHE_URL,
    SENTRY: allOr({ DSN: import.meta.env.SENTRY_DSN }),
    POSTHOG: allOr({
      KEY: import.meta.env.POSTHOG_KEY,
      HOST: import.meta.env.POSTHOG_HOST,
    }),
  };

  const result = parseEnvironment(EnvironmentSchema, raw);
  if (result.isErr) {
    logger.error(result.error.message, { issues: result.error.issues });
    throw new Error("Invalid environment configuration");
  }

  const parsed = result.value;
  if (parsed.SENTRY === null) {
    logger.warn("Sentry is not configured - error tracking disabled");
  }
  if (parsed.POSTHOG === null) {
    logger.warn("PostHog is not configured - analytics disabled");
  }

  const env: Environment = {
    ...parsed,
    SENTRY_ENABLED: parsed.SENTRY !== null,
    POSTHOG_ENABLED: parsed.POSTHOG !== null,
    SENTRY_RELEASE: parsed.APP_VERSION,
  };

  return env;
}

export const ENVIRONMENT = loadEnvironment();
export type { Environment };
